import React, { useState, useMemo } from 'react';
import { InputNumber, Slider, Row, Col, Tooltip, Radio, Switch} from 'antd';
import Constants from '../../../../SceneCreator/Constants';
import TripleToggleSwitch from "../../../../utils/triple-toggle-switch.js"
import {
    CloseOutlined
} from '@ant-design/icons';

function TransformControls (props) {

    const [hookDimensions, setDimensionsHook] = useState(false);
    const [activeUpdate, setActiveUpdate] = useState(false);
    const {placementType, changePlacementType, flipProduct, resetPlacementType, resetFreeModeTransform, freeMode, setFreeMode, snapToPointMode, setSnapToPointMode, snapToSurface, resetFlip, initialProductSize} = props;
    
    const [minSize, maxSize] = useMemo(() => {
        if (!initialProductSize) return [{ length: 0.1, height: 0.1, depth: 0.1 }, { length: 500, height: 500, depth: 500 }];
        return [
            {
                length: Math.max(initialProductSize.length - 50, 0.1),
                height: Math.max(initialProductSize.height - 50, 0.1),
                depth: Math.max(initialProductSize.depth - 50, 0.1)
            },
            {
                length: initialProductSize.length + 50,
                height: initialProductSize.height + 50,
                depth: initialProductSize.depth + 50
            }
        ];
    }, [initialProductSize]);

    const labels = {
        left: {
          title: "Rotation",
          value: "left"
        },
        right: {
          title: "Position",
          value: "right"
        },
        center: {
          title: "Off",
          value: "center"
        }
    };

    const freeModeOptions = {
        "rotate": "left",
        "off": "center",
        "translate": "right",
    }
    
    const onFreeRotationToggleChange = (value) => {
        let currentMode = Object.keys(freeModeOptions).find(key => freeModeOptions[key] === value);
        console.log("Free mode", currentMode);
        setFreeMode(currentMode);
    }

    const toggleSnapToPointMode = () => {
        setSnapToPointMode(!snapToPointMode);
    }

    const placementOptions = [
        { label: 'Floor', value: 'floor' },
        { label: 'Wall', value: 'wall' },
        { label: 'Ceiling', value: 'ceiling' },
      ];

    const updateProductLength = (value) => {
        if (activeUpdate && activeUpdate !== "length") return;
        if (value >= minSize.length && value <= maxSize.length) {
            setActiveUpdate("length");
            let length = value;
            let height = props.productSize.height;
            let depth = props.productSize.depth;
            if (hookDimensions) {
                let scale = length / props.productSize.length;
                height = parseFloat((props.productSize.height * scale).toFixed(3));;
                depth = parseFloat((props.productSize.depth * scale).toFixed(3));;
            }
            props.setProductSize(length, height, depth);
            setTimeout(() => setActiveUpdate(null), 0);
        }
    }

    const updateProductHeight = (value) => {
        if (activeUpdate && activeUpdate !== "height") return;
        if (value >= minSize.height && value <= maxSize.height) {
            setActiveUpdate("height");
            let length = props.productSize.length;
            let height = value;
            let depth = props.productSize.depth;
            if (hookDimensions) {
                let scale = height / props.productSize.height;
                length = parseFloat((props.productSize.length * scale).toFixed(3));;
                depth = parseFloat((props.productSize.depth * scale).toFixed(3));;
            }
            props.setProductSize(length, height, depth);
            setTimeout(() => setActiveUpdate(null), 0);
        }
    }

    const updateProductDepth = (value) => {
        if (activeUpdate && activeUpdate !== "depth") return;
        if (value >= minSize.depth && value <= maxSize.depth) {
            setActiveUpdate("depth");
            let length = props.productSize.length;
            let height = props.productSize.height;
            let depth = value;
            if (hookDimensions) {
                let scale = depth / props.productSize.depth;
                length = parseFloat((props.productSize.length * scale).toFixed(3));
                height = parseFloat((props.productSize.height * scale).toFixed(3));
            }
            props.setProductSize(length, height, depth);
            setTimeout(() => setActiveUpdate(null), 0);
        }
    }

    const onPlacementChange = ({ target: { value } }) => {
        changePlacementType(value)
    };

    const preventSpecialKeys =  (e) => {
        const allowedKeys = [
            'Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete', 'Home', 'End',
        ];
        const isNumber = /^[0-9]$/.test(e.key);
        const isDot = e.key === '.';
    
        if (!isNumber && !isDot && !allowedKeys.includes(e.key)) {
            e.preventDefault();
        }
    
        const inputValue = e.currentTarget.value;
        if (isDot && inputValue.includes('.')) {
            e.preventDefault();
        }
    }

    return (
        <>
            <div className='size-controls-container'>
                <strong className = "justify-in-center"><img className="transform-move-icon" draggable="false" src={require("../../../../assets/images/move-drag-icon.svg")}/></strong>
                    <div className='size-controls-cross-button' onClick={()=>{props.showProductSizeControls(false)}}>
                        <CloseOutlined />
                    </div>  
                <div className='size-controls-title-container'>
                    <span className='size-controls-text'>Resize</span>
                    <Tooltip title={<span className='manrope f-12 white'>Reset to original size of the product</span>}> 
                        <div className="size-controls-text reset prevent-select" onClick={()=>{props.resetProductSize()}}>
                            <div><img className='p-5 p-right' src={require("../../../../assets/images/reset-controls.svg")}/>Reset</div>
                    </div>
                    </Tooltip>
                </div>
                    
                <Row className='m-10 m-top'>
                    <Col span={22}>
                        <div  className='clipping-setting-div align-center' >
                            <span className='size-controls-text slider-text' >Width</span>
                            <Slider className='clipping-slider' onChange={(value)=>{ updateProductLength(value) }} tooltipVisible={false} trackStyle={{backgroundColor:"#276dd7"}} railStyle={{backgroundColor:"#cccccc"}} handleStyle={{backgroundColor:"#ffffff", borderColor:"#276dd7"}} step={5} min={minSize.length} max={maxSize.length} value={props.productSize.length}/>
                            <InputNumber
                            formatter={(value) => `${value}"`}
                            parser={(value) => (value.replace('"', ''))}
                            onKeyDown={preventSpecialKeys}
                            disabled={false} onChange={(value)=>{ updateProductLength(value) }}
                            step="5" className='size-controls-number-input' value={props.productSize.length} min={minSize.length} max={maxSize.length}/>
                        </div>
                        <div className='clipping-setting-div align-center'>
                            <span className='size-controls-text slider-text'>Height</span>
                            <Slider className='clipping-slider' onChange={(value)=>{ updateProductHeight(value) }} tooltipVisible={false} trackStyle={{backgroundColor:"#276dd7"}} railStyle={{backgroundColor:"#cccccc"}} handleStyle={{backgroundColor:"#ffffff", borderColor:"#276dd7"}} step={5} min={minSize.height} max={maxSize.height} value={props.productSize.height}/>
                            <InputNumber
                            formatter={(value) => `${value}"`}
                            parser={(value) => (value.replace('"', ''))}
                            onKeyDown={preventSpecialKeys}
                            disabled={false} onChange={(value)=>{ updateProductHeight(value) }} step="5" className='size-controls-number-input' value={props.productSize.height} min={minSize.height} max={maxSize.height}/>

                        </div>
                        <div className='clipping-setting-div align-center'>
                            <span className='size-controls-text slider-text'>Depth </span>
                            <Slider className='clipping-slider' onChange={(value)=>{ updateProductDepth(value) }} tooltipVisible={false} trackStyle={{backgroundColor:"#276dd7"}} railStyle={{backgroundColor:"#cccccc"}} handleStyle={{backgroundColor:"#ffffff", borderColor:"#276dd7"}} step={5} min={minSize.depth} max={maxSize.depth} value={props.productSize.depth}/>
                            <InputNumber
                            formatter={(value) => `${value}"`}
                            parser={(value) => (value.replace('"', ''))}
                            onKeyDown={preventSpecialKeys}
                            disabled={false} onChange={(value)=>{ updateProductDepth(value) }} step="5" className='size-controls-number-input' value={props.productSize.depth} min={minSize.depth} max={maxSize.depth}/>
                        </div>
                    </Col>
                    <Col className='size-controls-pin-icon-horizontal' span={1}>
                        <div className={`horizontal-divider ${hookDimensions ? 'enabled' : ''}`}></div>
                        <div className={`horizontal-divider ${hookDimensions ? 'enabled' : ''}`}></div>
                    </Col>
                    <Col className='size-controls-pin-icon-vertical' span={1}>
                        <div className={`vertical-divider ${hookDimensions ? 'enabled' : ''}`}></div>
                        <Tooltip title={<span className='manrope f-12 white'>Pin to uniformly resize product in all dimensions</span>}> 
                            <img className='pin-icon p-5 p-top p-bottom' onClick={()=> { setDimensionsHook(!hookDimensions) }} src={hookDimensions ? require("../../../../assets/images/pin-controls-selected.svg"): require("../../../../assets/images/pin-controls.svg") }/>
                        </Tooltip>
                        <div className={`vertical-divider ${hookDimensions ? 'enabled' : ''}`}></div>
                    </Col>
                </Row>
                { 
                    placementType === Constants.PlacementType.FLOOR && 
                    <div className='mt-20'>
                        <div>
                            <div className='size-controls-title-container m-10 m-top'>
                                <span className='size-controls-text'>
                                    Flip Item
                                </span>
                                <div>
                                    <Tooltip title={<span className='manrope f-12 white'>Reset flip of the product</span>}> 
                                        <div className="size-controls-text reset prevent-select" onClick={ resetFlip }>
                                            <div><img className='p-5 p-right' src={require("../../../../assets/images/reset-controls.svg")}/>Reset</div>
                                        </div>
                                    </Tooltip>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div onClick={flipProduct} className='size-controls-text flip-product-button prevent-select'>
                                <img alt = "rotate-product" src = {require("../../../../assets/images/rotate-icon.svg")}/>
                                <span> 
                                    Flip 90° 
                                 </span>
                            </div>
                        </div>
                    </div>
                }
                {
                    <div className='mt-20'>
                        <div>
                            <div className='size-controls-title-container m-10 m-top'>
                                <span className='size-controls-text'>
                                    Snap Product
                                </span>
                            </div>
                        </div>
                        <div>
                            <div className='flex-row justify-space-start w-100'>
                                <div onClick={()=>{toggleSnapToPointMode()}} className={`size-controls-text snap-product-button prevent-select ${snapToPointMode == true ? "selected" : ''}`}>
                                    <span>
                                        Snap to Point
                                    </span>
                                </div>
                                {placementType === Constants.PlacementType.FLOOR &&
                                    <div onClick={()=>{snapToSurface()}} className={`size-controls-text snap-product-button prevent-select`}>
                                        <span>
                                            Snap to Surface
                                        </span>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
                {
                    <div className='mt-20'>
                        <div>
                            <div className='size-controls-title-container m-10 m-top'>
                                <span className='size-controls-text'>
                                    Free Mode
                                </span>
                                <Tooltip title={<span className='manrope f-12 white'>Reset rotation / position of the product</span>}> 
                                    <div className="size-controls-text reset prevent-select" onClick={ resetFreeModeTransform }>
                                        <div><img className='p-5 p-right' src={require("../../../../assets/images/reset-controls.svg")}/>Reset</div>
                                    </div>
                                </Tooltip>
                                
                            </div>
                            <div className='free-rotation-toggle prevent-select'>
                                <TripleToggleSwitch labels={labels} toggleState={freeModeOptions[freeMode]} onChange={onFreeRotationToggleChange} />
                            </div>
                        </div>
                    </div>
                }
                <Row className='mt-20'>
                    <div className='size-controls-title-container'>
                        <span className='size-controls-text'>Change Placement</span>
                        <Tooltip title={<span className='manrope f-12 white'>Reset to original placement of the product</span>}> 
                        <div className="size-controls-text reset prevent-select" onClick={ resetPlacementType }>
                            <div><img className='p-5 p-right' src={require("../../../../assets/images/reset-controls.svg")}/>Reset</div>
                        </div>
                        </Tooltip>
                    </div>
                    <Radio.Group 
                        className='mt-16'
                        options={placementOptions} 
                        onChange={onPlacementChange}  
                        value={placementType}
                    />
                </Row>
 
            </div>

        </>
    )
}

export default TransformControls